import { Admin, Resource } from 'react-admin';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { authProvider } from './authProvider';
import { dataProvider } from './dataProvider';
import { Layout } from './layout/Layout';
import { LoginPage } from './layout/LoginPage';
import { Dashboard } from './resources/dashboard/Dashboard';
import { BootstrapTokenList, BootstrapTokenCreate, BootstrapTokenShow } from './resources/bootstrapTokens';
import { DeviceList, DeviceShow } from './resources/devices';
import { NodeClaimList, NodeClaimArm } from './resources/nodeClaims';
import { UserList, UserEdit } from './resources/users';
import { AuditLogList } from './resources/auditLogs';
import { AnalyticsDashboard } from './resources/analytics';
import { EmailTemplateList } from './resources/emailTemplates';
import { ApiKeyCreate } from './resources/apiKeys';
import { theme } from './theme';

import KeyIcon from '@mui/icons-material/KeyOutlined';
import DevicesIcon from '@mui/icons-material/DevicesOutlined';
import MemoryIcon from '@mui/icons-material/MemoryOutlined';
import PeopleIcon from '@mui/icons-material/PeopleOutlined';
import CodeIcon from '@mui/icons-material/CodeOutlined';
import HistoryIcon from '@mui/icons-material/History';
import BarChartIcon from '@mui/icons-material/BarChart';
import EmailIcon from '@mui/icons-material/Email';

export const App = () => (
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <Admin
            authProvider={authProvider}
            dataProvider={dataProvider}
            layout={Layout}
            loginPage={LoginPage}
            dashboard={Dashboard}
            title="XTConnect Admin"
            theme={theme}
        >
            <Resource
                name="bootstrap-tokens"
                list={BootstrapTokenList}
                create={BootstrapTokenCreate}
                show={BootstrapTokenShow}
                icon={KeyIcon}
                options={{ label: 'Bootstrap Tokens' }}
            />
            <Resource
                name="node-claims"
                list={NodeClaimList}
                create={NodeClaimArm}
                icon={MemoryIcon}
                options={{ label: 'Node Claims' }}
            />
            <Resource
                name="devices"
                list={DeviceList}
                show={DeviceShow}
                icon={DevicesIcon}
            />
            <Resource
                name="users"
                list={UserList}
                edit={UserEdit}
                icon={PeopleIcon}
            />
            <Resource
                name="api-keys"
                list={ApiKeyCreate}
                create={ApiKeyCreate}
                icon={CodeIcon}
                options={{ label: 'API Keys' }}
            />
            <Resource
                name="audit-logs"
                list={AuditLogList}
                icon={HistoryIcon}
                options={{ label: 'Audit Logs' }}
            />
            <Resource
                name="analytics"
                list={AnalyticsDashboard}
                icon={BarChartIcon}
            />
            <Resource
                name="email-templates"
                list={EmailTemplateList}
                icon={EmailIcon}
                options={{ label: 'Email Templates' }}
            />
        </Admin>
    </ThemeProvider>
);

export default App;
